"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayloadTooLarge = void 0;
const ApiException_1 = require("./ApiException");
class PayloadTooLarge extends ApiException_1.ApiException {
    constructor(message = 'Payload Too Large', data) {
        super(message, data);
    }
}
exports.PayloadTooLarge = PayloadTooLarge;
